  <div class="ig-profile__topbar">
    <button
      type="button"
      class="ig-profile__back-btn"
      (click)="goBackToFeed()"
      [attr.aria-label]="'socialFeed.back' | transloco"
    >
      <i class="pi pi-arrow-left"></i>
      <span>{{ "socialFeed.back" | transloco }}</span>
    </button>
  </div>

  <!-- LOADING -->
  <div class="ig-profile__loading" *ngIf="loading">
    <p-progressSpinner [style]="{ width: '48px', height: '48px' }"></p-progressSpinner>
  </div>

  <!-- 404: perfil inexistente ou oculto (bloqueio em qualquer sentido / sanção) — mesmo aviso, de propósito -->
  <div class="ig-profile__loading" *ngIf="!loading && profileUnavailable">
    <p class="ig-profile__empty">{{ 'socialFeed.profileUnavailable' | transloco }}</p>
  </div>

  <div class="ig-profile" *ngIf="!loading && profile">
    <!-- HEADER (vitrine) -->
    <div class="ig-profile__header">
      <div class="ig-profile__avatar">
        <img *ngIf="profile.avatarUrl" [src]="profile.avatarUrl" class="ig-profile__avatar-img" alt="Avatar" />
        <span *ngIf="!profile.avatarUrl" class="ig-profile__avatar-placeholder">{{ avatarInitial }}</span>
      </div>

      <div class="ig-profile__info">
        <div class="ig-profile__identity">
          <div class="ig-profile__identity-row">
            <h1 class="ig-profile__username">{{ profile.nickname || profile.name || profile.userId }}</h1>
            <!-- Menu "⋯" ao lado do nome (fecha ao clicar fora / Esc). Visitante: denunciar / bloquear a pessoa. Dono: lista de bloqueados. -->
            <div class="ig-profile__kebab" #profileKebab *ngIf="currentUserId">
              <button
                type="button"
                class="ig-profile__more"
                (click)="showProfileActions = !showProfileActions"
                aria-label="Ações do perfil"
              >
                <i class="pi pi-ellipsis-v"></i>
              </button>
              <div class="ig-profile__dropdown" *ngIf="showProfileActions">
                <ng-container *ngIf="!isOwnProfile">
                  <button type="button" (click)="reportProfile()">{{ 'socialFeed.reportUser' | transloco }}</button>
                  <button type="button" (click)="blockProfile()">{{ 'socialFeed.blockUser' | transloco }}</button>
                </ng-container>
                <button type="button" *ngIf="isOwnProfile" (click)="openBlockedUsers()">{{ 'socialFeed.blockedUsers' | transloco }}</button>
              </div>
            </div>
          </div>
          <p class="ig-profile__fullname" *ngIf="profile.name && profile.name !== profile.nickname">{{ profile.name }}</p>
        </div>

        <div class="ig-profile__stats">
          <div class="ig-profile__stat">
            <span class="ig-profile__stat-value">{{ displayProjectsCount }}</span>
            <span class="ig-profile__stat-label">{{ "socialFeed.projects" | transloco }}</span>
          </div>
          <!-- Projetos que sigo: só no próprio perfil; abre a lista. -->
          <button type="button" class="ig-profile__stat ig-profile__stat--link" *ngIf="isOwnProfile" (click)="openFollowedProjects()">
            <span class="ig-profile__stat-value">{{ followedTotal }}</span>
            <span class="ig-profile__stat-label">{{ "socialFeed.following" | transloco }}</span>
          </button>
          <div class="ig-profile__stat" *ngIf="badgesCount > 0">
            <span class="ig-profile__stat-value">{{ badgesCount }}</span>
            <span class="ig-profile__stat-label">{{ "socialFeed.badges" | transloco }}</span>
          </div>
          <div class="ig-profile__stat" *ngIf="marketplaceItemsCount > 0">
            <span class="ig-profile__stat-value">{{ marketplaceItemsCount }}</span>
            <span class="ig-profile__stat-label">{{ "socialFeed.marketplaceItems" | transloco }}</span>
          </div>
        </div>

        <p class="ig-profile__bio" *ngIf="profile.bio">{{ profile.bio }}</p>
        <a class="ig-profile__website" *ngIf="profile.website" [href]="profile.website" target="_blank" rel="noopener noreferrer">{{ profile.website }}</a>

        <div class="ig-profile__actions">
          <button *ngIf="isOwnProfile" class="ig-profile__edit-btn" (click)="openEditModal()">
            {{ 'socialFeed.editProfile' | transloco }}
          </button>
          <app-social-report-dialog #reportDialog></app-social-report-dialog>
          <app-social-block-dialog #blockDialog (blocked)="onBlocked()"></app-social-block-dialog>
        </div>
      </div>
    </div>

    <!-- MOBILE STATS -->
    <div class="ig-profile__stats-mobile">
      <div class="ig-profile__stat">
        <span class="ig-profile__stat-value">{{ displayProjectsCount }}</span>
        <span class="ig-profile__stat-label">{{ "socialFeed.projects" | transloco }}</span>
      </div>
      <button type="button" class="ig-profile__stat ig-profile__stat--link" *ngIf="isOwnProfile" (click)="openFollowedProjects()">
        <span class="ig-profile__stat-value">{{ followedTotal }}</span>
        <span class="ig-profile__stat-label">{{ "socialFeed.following" | transloco }}</span>
      </button>
      <div class="ig-profile__stat" *ngIf="badgesCount > 0">
        <span class="ig-profile__stat-value">{{ badgesCount }}</span>
        <span class="ig-profile__stat-label">{{ "socialFeed.badges" | transloco }}</span>
      </div>
      <div class="ig-profile__stat" *ngIf="marketplaceItemsCount > 0">
        <span class="ig-profile__stat-value">{{ marketplaceItemsCount }}</span>
        <span class="ig-profile__stat-label">{{ "socialFeed.marketplaceItems" | transloco }}</span>
      </div>
    </div>

    <!-- PROJECTS (grid compartilhado por template; seções variam por visibilidade) -->
    <ng-template #projectsGrid let-list>
      <div class="ig-profile__grid">
        <div
          class="ig-profile__grid-item project"
          *ngFor="let pr of list"
          (click)="openProjectProfile(pr.projectID)"
          [style.background-image]="projectThumbStyle(pr)"
        >
          <div class="ig-profile__grid-project-label">{{ pr.projectName }}</div>
        </div>
      </div>
    </ng-template>

    <div class="ig-profile__grid-loading" *ngIf="projectsLoading">
      <p-progressSpinner [style]="{ width: '32px', height: '32px' }"></p-progressSpinner>
    </div>

    <ng-container *ngIf="!projectsLoading">
      <!-- Visitante: só projetos públicos -->
      <ng-container *ngIf="!isOwnProfile">
        <h2 class="ig-profile__section-title">
          <i class="pi pi-car"></i>
          {{ "socialFeed.tabProjects" | transloco }}
        </h2>
        <ng-container *ngTemplateOutlet="projectsGrid; context: { $implicit: publicProjects }"></ng-container>
        <p class="ig-profile__empty" *ngIf="!publicProjects.length">{{ "socialFeed.noProjects" | transloco }}</p>
      </ng-container>

      <!-- Dono: seções separadas por visibilidade -->
      <ng-container *ngIf="isOwnProfile">
        <ng-container *ngIf="publicProjects.length">
          <h2 class="ig-profile__section-title">
            <i class="pi pi-car"></i>
            {{ "socialFeed.projectsPublic" | transloco }}
          </h2>
          <ng-container *ngTemplateOutlet="projectsGrid; context: { $implicit: publicProjects }"></ng-container>
        </ng-container>

        <ng-container *ngIf="linkProjects.length">
          <h2 class="ig-profile__section-title ig-profile__section-title--stacked">
            <i class="pi pi-car"></i>
            {{ "socialFeed.projectsLink" | transloco }}
          </h2>
          <ng-container *ngTemplateOutlet="projectsGrid; context: { $implicit: linkProjects }"></ng-container>
        </ng-container>

        <ng-container *ngIf="privateProjects.length">
          <h2 class="ig-profile__section-title ig-profile__section-title--stacked">
            <i class="pi pi-car"></i>
            {{ "socialFeed.projectsPrivate" | transloco }}
          </h2>
          <ng-container *ngTemplateOutlet="projectsGrid; context: { $implicit: privateProjects }"></ng-container>
        </ng-container>

        <p
          class="ig-profile__empty"
          *ngIf="!publicProjects.length && !linkProjects.length && !privateProjects.length"
        >
          {{ "socialFeed.noProjects" | transloco }}
        </p>
      </ng-container>
    </ng-container>
  </div>

  <!-- USUÁRIOS BLOQUEADOS (só o dono) -->
  <p-dialog
    [(visible)]="blockedDialogVisible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [header]="'socialFeed.blockedUsers' | transloco"
    [style]="{ width: 'min(420px, 95vw)' }"
    styleClass="ig-followers-dialog"
  >
    <div class="ig-blocked-list">
      <div *ngIf="blockedLoading" class="ig-blocked-list__loading">
        <p-progressSpinner [style]="{ width: '28px', height: '28px' }"></p-progressSpinner>
      </div>

      <div *ngFor="let u of blockedUsers" class="ig-blocked-list__item">
        <span class="ig-blocked-list__avatar">{{ blockedDisplay(u).charAt(0).toUpperCase() }}</span>
        <span class="ig-blocked-list__name">{{ blockedDisplay(u) }}</span>
        <button
          type="button"
          class="ig-blocked-list__unblock"
          [disabled]="unblockingUserId !== null"
          (click)="unblock(u)"
        >
          <i *ngIf="unblockingUserId === u.userId" class="pi pi-spin pi-spinner"></i>
          {{ 'socialFeed.unblock' | transloco }}
        </button>
      </div>

      <p class="ig-blocked-list__empty" *ngIf="!blockedLoading && !blockedUsers.length">
        {{ 'socialFeed.noBlockedUsers' | transloco }}
      </p>
    </div>
  </p-dialog>

  <!-- PROJETOS QUE SIGO (só o dono) -->
  <p-dialog
    [(visible)]="followedDialogVisible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [header]="'socialFeed.followedProjects' | transloco"
    [style]="{ width: 'min(440px, 95vw)' }"
    styleClass="ig-followers-dialog"
  >
    <div class="ig-blocked-list ig-followed-list" (scroll)="onFollowedListScroll($event)">

      <button
        type="button"
        *ngFor="let p of followedProjects"
        class="ig-blocked-list__item ig-followed-item"
        (click)="openFollowedProject(p)"
      >
        <span class="ig-followed-item__thumb">
          <img *ngIf="p.primaryImageUrl" [src]="p.primaryImageUrl" alt="" />
          <i *ngIf="!p.primaryImageUrl" class="pi pi-car"></i>
        </span>
        <span class="ig-followed-item__text">
          <span class="ig-blocked-list__name">{{ p.projectName }}</span>
          <span class="ig-followed-item__meta">
            <ng-container *ngIf="followedVehicle(p)">{{ followedVehicle(p) }}</ng-container>
            <ng-container *ngIf="followedVehicle(p) && p.ownerNickname"> · </ng-container>
            <ng-container *ngIf="p.ownerNickname">&#64;{{ p.ownerNickname }}</ng-container>
          </span>
        </span>
        <i class="pi pi-angle-right ig-followed-item__chevron"></i>
      </button>

      <!-- Spinner no fim da lista: cobre a primeira carga e as páginas seguintes. -->
      <div *ngIf="followedLoading" class="ig-blocked-list__loading">
        <p-progressSpinner [style]="{ width: '28px', height: '28px' }"></p-progressSpinner>
      </div>

      <p class="ig-blocked-list__empty" *ngIf="!followedLoading && !followedProjects.length">
        {{ 'socialFeed.noFollowedProjects' | transloco }}
      </p>
    </div>
  </p-dialog>

  <!-- EDIT PROFILE DIALOG -->
  <p-dialog
    [(visible)]="editVisible"
    [modal]="true"
    [draggable]="false"
    [header]="'socialFeed.editProfile' | transloco"
    [style]="{ width: 'min(480px, 95vw)' }"
    styleClass="ig-profile-edit-dialog"
  >
    <div class="ig-edit">

      <!-- Avatar -->
      <div class="ig-edit__avatar-section">
        <div class="ig-profile__avatar ig-edit__avatar-preview">
          <img *ngIf="avatarPreviewUrl" [src]="avatarPreviewUrl" class="ig-profile__avatar-img" alt="Avatar" />
          <span *ngIf="!avatarPreviewUrl" class="ig-profile__avatar-placeholder">{{ avatarInitial }}</span>
          <div class="ig-edit__avatar-uploading" *ngIf="isUploadingAvatar">
            <p-progressSpinner [style]="{ width: '24px', height: '24px' }"></p-progressSpinner>
          </div>
        </div>
        <label class="ig-edit__change-photo-btn">
          {{ 'socialFeed.changePhoto' | transloco }}
          <input type="file" accept=".jpg,.jpeg,.png,.webp,.gif,.avif,image/jpeg,image/png,image/webp,image/gif,image/avif" (change)="onAvatarSelected($event)" hidden />
        </label>
      </div>

      <!-- Nickname -->
      <div class="ig-edit__field">
        <label class="ig-edit__label" for="profileNicknameInput">{{ 'socialFeed.nickname' | transloco }}</label>
        <input
          id="profileNicknameInput"
          class="ig-edit__input"
          [class.ig-edit__input--invalid]="nicknameConflict || nicknameTooLong"
          type="text"
          maxlength="100"
          autocomplete="off"
          [placeholder]="'socialFeed.nicknamePlaceholder' | transloco"
          [(ngModel)]="editNickname"
          (ngModelChange)="onNicknameChange()"
        />
        <span class="ig-edit__char-count">{{ editNickname.length }}/100</span>
        <p class="ig-edit__field-error" *ngIf="nicknameEmpty">
          {{ 'socialFeed.nicknameRequired' | transloco }}
        </p>
        <p class="ig-edit__field-error" *ngIf="!nicknameEmpty && nicknameTooLong">
          {{ 'socialFeed.nicknameTooLong' | transloco }}
        </p>
        <p class="ig-edit__field-error" *ngIf="nicknameConflict">
          {{ 'socialFeed.nicknameConflict' | transloco }}
        </p>
      </div>

      <!-- Bio -->
      <div class="ig-edit__field">
        <label class="ig-edit__label">{{ 'socialFeed.bio' | transloco }}</label>
        <textarea
          class="ig-edit__textarea"
          rows="4"
          maxlength="500"
          [placeholder]="'socialFeed.bioPlaceholder' | transloco"
          [(ngModel)]="editBio"
        ></textarea>
        <span class="ig-edit__char-count">{{ editBio.length }}/500</span>
      </div>

      <!-- Website -->
      <div class="ig-edit__field">
        <label class="ig-edit__label">{{ 'socialFeed.website' | transloco }}</label>
        <input
          class="ig-edit__input"
          type="url"
          [placeholder]="'socialFeed.websitePlaceholder' | transloco"
          [(ngModel)]="editWebsite"
          maxlength="200"
        />
      </div>

      <!-- Erro -->
      <p class="ig-edit__error" *ngIf="saveError">{{ saveError }}</p>

      <!-- Salvar -->
      <button
        class="ig-edit__save-btn"
        [disabled]="!canSaveProfile"
        (click)="saveProfile()"
      >
        {{ isSaving ? ('socialFeed.saving' | transloco) : ('socialFeed.save' | transloco) }}
      </button>

    </div>
  </p-dialog>

  <!-- Ajuste de recorte (1:1, circular) antes de subir a nova foto. -->
  <app-avatar-cropper [(visible)]="avatarCropperVisible" [file]="avatarFileToCrop"
                      (cropped)="onAvatarCropped($event)"></app-avatar-cropper>
